import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faClock,
  faChartLine,
  faDatabase,
} from "@fortawesome/free-solid-svg-icons";
import "./TriageCategoryStrip.css";

const STRIP_ITEMS = [
  {
    bucket: "action",
    tone: "red",
    title: "Action Needed",
    subKey: "action",
    icon: faExclamationTriangle,
    desc: "New or unresolved issues requiring prompt follow-up.",
  },
  {
    bucket: "monitor",
    tone: "amber",
    title: "Monitor",
    subKey: "monitor",
    icon: faClock,
    desc: "Changes worth watching closely and reviewing soon.",
  },
  {
    bucket: "stable",
    tone: "green",
    title: "Stable / Improved",
    subKey: "stable",
    icon: faChartLine,
    desc: "Positive or stable changes with no urgent action needed.",
    hideAssigned: true,
  },
  {
    bucket: "review",
    tone: "gray",
    title: "Review Data",
    subKey: "reviewData",
    icon: faDatabase,
    desc: "Missing, stale, conflicting, or insufficient information requiring review.",
    hideAssigned: true,
  },
];

export default function TriageCategoryStrip({ summary, activeBucket = "action" }) {
  return (
    <div className="triage-strip" role="navigation" aria-label="Triage categories">
      {STRIP_ITEMS.map(
        ({ bucket, tone, title, subKey, icon, desc, hideAssigned }) => {
          const data = summary?.[subKey] || {
            total: 0,
            newCount: 0,
            assignedCount: 0,
          };
          const meta = hideAssigned
            ? null
            : `${data.newCount || 0} New · ${data.assignedCount || 0} Assigned`;

          return (
            <Link
              key={bucket}
              to={`/care/triage?bucket=${bucket}&tab=new`}
              className={`triage-strip__card triage-strip__card--${tone}${
                activeBucket === bucket ? " is-active" : ""
              }`}
            >
              <div className="triage-strip__top">
                <span className="triage-strip__icon">
                  <FontAwesomeIcon icon={icon} />
                </span>
                <span className="triage-strip__value">{data.total ?? 0}</span>
              </div>
              {meta ? <div className="triage-strip__meta">{meta}</div> : null}
              <div className="triage-strip__title">{title}</div>
              <p className="triage-strip__desc">{desc}</p>
            </Link>
          );
        },
      )}
    </div>
  );
}
